import Vue from 'vue'

import VueRouter from 'vue-router'


Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
    }
  ]
})
export const asyncRoutes = {
  home: {
    path: '/home',
    name: '首页',
    component: () => import('@/views/centre'),
  },

  /**
   * 课程管理
   */
  courseList: {
    path: '/course/courseList',
    name: '课程列表',
    component: () => import('@/views/course/courseList/index'),
  },
  courseVersion: {
    path: '/course/courseVersion',
    name: '课程版本',
    component: () => import('@/views/course/courseVersion/index'),
  },
  courseType: {
    path: '/course/courseType',
    name: '课程类型',
    component: () => import('@/views/course/courseType/index'),
  },
  courseBook: {
    path: '/course/courseBook',
    name: '课程书册',
    component: () => import('@/views/course/courseBook/index'),
  },
  courseSort: {
    path: '/course/courseSort',
    name: '课程分类',
    component: () => import('@/views/course/courseSort/index'),
  },
  coursePoint: {
    path: '/course/coursePoint',
    name: '课程分类',
    component: () => import('@/views/course/coursePoint/index'),
  },
  /**
   * 基础设置
   */
  schoolConfig: {
    path: '/config/schoolConfig',
    name: '学科管理',
    component: () => import('@/views/config/schoolConfig/index'),
  },
  subject: {
    path: '/config/subject',
    name: '学科管理',
    component: () => import('@/views/config/subject/index'),
  },
  sysClass: {
    path: '/config/sysClass',
    name: '年级管理',
    component: () => import('@/views/config/sysClass/index'),
  },
  banner: {
    path: '/config/banner',
    name: 'banner设置',
    component: () => import('@/views/config/banner/index'),
  },
  webConfig: {
    path: '/config/webConfig',
    name: '程序配置',
    component: () => import('@/views/config/webConfig/index'),
  },
  linkConfig: {
    path: '/config/linkConfig',
    name: '外网链接',
    component: () => import('@/views/config/linkConfig/index'),
  },
  choicePlan: {
    path: '/config/choicePlan',
    name: '选课规划',
    component: () => import('@/views/config/choicePlan/index'),
  },
  region: {
    path: '/config/region',
    name: '地区管理',
    component: () => import('@/views/sys/region/index'),
  },
  /**
   * 消息通知
   */
  message: {
    path: '/message/system',
    name: '系统通知',
    component: () => import('@/views/message/system/index'),
  },
  /**
   * 资源中心
   */
  paperResource: {
    path: '/resource/paperResource',
    name: '年级试卷',
    component: () => import('@/views/resource/paperResource/index'),
  },
  resource: {
    path: '/resource/resource',
    name: '高考真题',
    component: () => import('@/views/resource/topicResource/index'),
  },
  articleResource: {
    path: '/resource/articleResource',
    name: '作文天地',
    component: () => import('@/views/resource/articleResource/index'),
  },
  /**
   * 心灵成长
   */
  inspirational: {
    path: '/inspirational/inspirationalList',
    name: '心灵励志',
    component: () => import('@/views/inspirational/inspirationalList/index'),
  },
  safety: {
    path: '/inspirational/safety',
    name: '安全教育',
    component: () => import('@/views/inspirational/safety/index'),
  },
  historyRelated: {
    path: '/inspirational/historyRelated',
    name: '历史人文',
    component: () => import('@/views/inspirational/historyRelated/index'),
  },
  music: {
    path: '/inspirational/music',
    name: '心灵FM',
    component: () => import('@/views/inspirational/music/index'),
  },
  appraisal: {
    path: '/inspirational/appraisal',
    name: '心灵测评',
    component: () => import('@/views/inspirational/memberAppraisal/index'),
  },
  /**
   * 题库管理
   */
  topicList: {
    path: '/topic/topicList',
    name: '试题列表',
    component: () => import('@/views/topic/topicList/index'),
  },
  topicVersion: {
    path: '/topic/topicVersion',
    name: '试题版本.书册',
    component: () => import('@/views/topic/topicVersion/index'),
  },
  section: {
    path: '/topic/section',
    name: '章节分类',
    component: () => import('@/views/topic/section/index'),
  },
  point: {
    path: '/topic/point',
    name: '知识点分类',
    component: () => import('@/views/topic/point/index'),
  },
  topicExam: {
    path: '/topic/topicExam',
    name: '知识点分类',
    component: () => import('@/views/topic/topicExam/index'),
  },
  /**
   * 学员管理
   */
  memberList: {
    path: '/member/memberList',
    name: '学员列表',
    component: () => import('@/views/member/memberList/index'),
  },
  memberInfo: {
    path: '/member/memberInfo',
    name: '学习记录',
    component: () => import('@/views/member/memberInfo/index'),
  },
  memberLog: {
    path: '/member/memberLog',
    name: '反馈记录',
    component: () => import('@/views/member/memberLog/index'),
  },

  /**
   * 教师管理
   */
  teacherList: {
    path: '/teacher/teacherList',
    name: '教师列表',
    component: () => import('@/views/teacher/teacherList/index'),
  },
  prepareLessons: {
    path: '/teacher/prepareLessons',
    name: '备课中心',
    component: () => import('@/views/teacher/prepareLessons/index'),
  },
  schoolResource: {
    path: '/teacher/schoolResource',
    name: '校本空间',
    component: () => import('@/views/teacher/schoolResource/index'),
  },
  teacherResourceSort: {
    path: '/teacher/teacherResourceSort',
    name: '课时分类',
    component: () => import('@/views/teacher/teacherResourceSort/index'),
  },
  resourceVersion: {
    path: '/teacher/resourceVersion',
    name: '课件版本.书册',
    component: () => import('@/views/teacher/resourceVersion/index'),
  },
  resourceSection: {
    path: '/teacher/resourceSection',
    name: '课件章节',
    component: () => import('@/views/teacher/resourceSection/index'),
  },
  resourcePoint: {
    path: '/teacher/resourcePoint',
    name: '课件知识点',
    component: () => import('@/views/teacher/resourcePoint/index'),
  },
  /**
   * 学习卡
   */
  learnCard: {
    path: '/learnCard/learnCardList',
    name: '学习卡列表',
    component: () => import('@/views/learnCard/learnCardList/index'),
  },
  /**
   * sys 系统
   */
  sysMenu: {
    path: '/sys/menu/menu-list',
    name: '菜单管理',
    component: () => import('@/views/sys/menu/index'),
  },
  sysRole: {
    path: "/sys/role",
    name: "角色管理",
    component: () => import("@/views/sys/role/index")
  },
  sysUser: {
    path: "/sys/user",
    name: "账户管理",
    component: () => import("@/views/sys/user/index")
  },
  sysTableList: {
    path: '/sys/table/table-list',
    name: '代码生成',
    component: () => import('@/views/sys/table/index'),
  },

}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js